module.exports = __webpack_public_path__ + "img/stato-pratiche-emt.ca24b89a.png";